import type { FC } from 'react'

import { twJoin } from 'tailwind-merge'

import { useAppContext } from '@/App.context'

import { costBarBgStyleByWhiteLabel } from '../util/style-constant'

export const CartCostBar: FC<{
  isSpendingLimitExceeded: boolean
  coverPct: number
  usedPct: number
}> = ({ isSpendingLimitExceeded, coverPct, usedPct }) => {
  const { whiteLabel } = useAppContext()
  const bgColor = costBarBgStyleByWhiteLabel[whiteLabel] || costBarBgStyleByWhiteLabel.skytech

  return (
    <div
      className={twJoin(
        'relative mb-1.5 mt-2 h-2 w-full overflow-hidden rounded-full transition-all duration-500 ease-out',
        isSpendingLimitExceeded ? bgColor?.error : bgColor?.warning
      )}
    >
      <div
        className={twJoin(
          'absolute left-0 top-0 h-full transition-all duration-500 ease-out',
          isSpendingLimitExceeded ? 'bg-white/40' : bgColor?.success
        )}
        style={{ width: `${coverPct * 100}%` }}
      />
      <div
        className={twJoin(
          'absolute right-0 top-0 h-full transition-all duration-500 ease-out',
          isSpendingLimitExceeded ? bgColor?.error : 'bg-white/80'
        )}
        style={{
          width: isSpendingLimitExceeded ? `${(1 - coverPct) * 100}%` : `${(1 - usedPct) * 100}%`,
        }}
      />
    </div>
  )
}
